import React from "react";
import { Flex, Image, Grid } from "antd";
import { Link } from "react-router-dom";
import Logo from "../Logo/Logo";
import BlueButton from "../../../components/UI/Buttons/BlueButton";
import logo2 from "../../../images/Signet-blue.png";
import { clrs } from "../../../constants/colors";

const { useBreakpoint } = Grid;

const Header = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Flex
      style={{
        width: "100%",
        position: "absolute",
        padding: isMobile ? "10px 15px" : "0 30px",
        top: 0,
        zIndex: 10,
        backgroundColor: "transparent",
      }}
      justify="center"
    >
      <Flex
        style={{
          width: "100%",
          maxWidth: 1440,
          padding: "20px 0",
          flexDirection: isMobile ? "column" : "row",
        }}
        align="center"
        justify={isMobile ? "center" : "space-between"}
        gap={isMobile ? 20 : 50}
      >
        <Flex align="center" justify="center" gap={12}>
          <Logo />
          <Image
            width={isMobile ? 100 : 120}
            src={logo2}
            preview={false}
            alt="Partner logo"
          />
        </Flex>

        <Flex
          align="center"
          justify={isMobile ? "center" : "end"}
          gap={isMobile ? 10 : 30}
          wrap
        >
          <Link
            to="/documents"
            style={{
              color: clrs.blue,
              textDecoration: "none",
              fontWeight: 500,
            }}
          >
            Гарын авлага
          </Link>

          <Link
            to="/policy"
            style={{
              color: clrs.blue,
              textDecoration: "none",
              fontWeight: 500,
            }}
          >
            Нууцлалын Бодлого
          </Link>

          <Link
            to="/support"
            style={{
              color: clrs.blue,
              textDecoration: "none",
              fontWeight: 500,
            }}
          >
            Холбоо барих
          </Link>
          <Link to="/login">
            <BlueButton
              style={{
                fontSize: "1rem",
                padding: isMobile ? "8px 16px" : "10px 20px",
              }}
            >
              Нэвтрэх
            </BlueButton>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Header;
